import AIGroupPathDto from "./AIGroupPathDto";
import AIGroupUserDto from "./AIGroupUserDto";

export default class AIGroupDto {

    AIGroupId: number;
    Name: string;
    Paths: AIGroupPathDto[];
    Users: AIGroupUserDto[];
    UserIds: number[];

    constructor(aiGroupId: number, name: string, paths: AIGroupPathDto[], users: AIGroupUserDto[]) {
        this.AIGroupId = aiGroupId;
        this.Name = name;
        this.Paths = paths;
        this.Users = users;
        this.UserIds = users.map(u => u.UserId);
    }
}
